import { Notify, type QNotifyCreateOptions } from "quasar";

import { type Nullable } from "shared/types";

const DEFAULT_TIMEOUT = 3000;

export function useNotify() {
  function successNotification(options: QNotifyCreateOptions = {}): void {
    if (!options.message) {
      return;
    }

    Notify.create({
      classes: "tw:font-bold tw:line-height-[140%]",
      color: "ds-green-1",
      icon: "check_circle",
      textColor: "ds-green-7",
      timeout: DEFAULT_TIMEOUT,
      ...options,
    });
  }

  function loadingNotification(
    options: QNotifyCreateOptions = {}
  ): Nullable<ReturnType<typeof Notify.create>> {
    if (!options.message) {
      return null;
    }

    const dismissFunction = Notify.create({
      classes: "tw:font-bold tw:line-height-[140%]",
      color: "ds-blue-1",
      message: options.message,
      spinner: true,
      spinnerSize: "sm",
      textColor: "ds-blue-7",
      timeout: 0,
      ...options,
    });

    return dismissFunction;
  }

  return {
    loadingNotification,
    successNotification,
  };
}

export default useNotify;
